import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AppService } from '../../../services/app.service';

import { ITableColumn } from '../../../shared/table/table.component';
import { HospitalService } from '../../../services/hospital.service';
import { IHospitalContactPerson } from '../../../models/Hospital';

const cache: {
    persons?: IHospitalContactPerson[]
} = {};

@Component({
    selector: 'app-hospital-dashboard-employee-select',
    templateUrl: './hospital-dashboard-employee-select.component.html'
})
export class HospitalDashboardEmployeeSelectComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: HospitalService,
        private modal: NgbActiveModal
    ) { }

    readonly columns: ITableColumn[] = [
        { property: 'Name', label: 'hospitalDashboard_employeeSelect_lblPerson', sorts: true },
        { label: 'hospitalDashboard_employeeSelect_lblCompany' },
        { width: '1px' }
    ];

    rows: IHospitalContactPerson[] = [];
    searchTerm: string;

    private persons: IHospitalContactPerson[] = [];

    ngOnInit() {
        if (cache.persons) {
            this.persons = cache.persons;
            this.rows = cache.persons;
        } else {
            this.app.addLoading(this.service.getContactPersons()).subscribe(data => {
                this.persons = cache.persons = data;
                this.rows = data;
            });
        }
    }

    select(person: IHospitalContactPerson) {
        this.modal.close(person);
    }

    cancel() {
        this.modal.dismiss();
    }

    filter() {
        const s = this.searchTerm?.toLowerCase();

        if (s) {
            this.rows = this.persons.filter(t => {
                return `${t.Name} ${t.Surname}`.toLowerCase().includes(s)
                    || t.Email.toLowerCase().includes(s)
                    || t.Companies.some(n => n.toLowerCase().includes(s))
            });
        } else {
            this.rows = this.persons;
        }
    }
}
